import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';

import SubPageNavigation from 'components/SubPageNavigation';
import AccountBalancesList from 'components/billing/AccountBalancesList';
import BillingAccountOverview from 'components/billing/BillingAccountOverview';
import BillingItemCalendar from 'components/billing/BillingItemCalendar';
import {
  addItem,
  deleteItem,
  editItem,
  reverseItem,
  repostItem,
  editInstallments,
  sendStatement,
  SendStatement,
  UnexpectedError,
  ConfirmDelete,
  MissingEmail
} from 'components/shared/BillingItems';
import ModalRoot from '../ModalRoot';
import BillingAuditViewer from './BillingAuditViewer';
import BillingItemList from './BillingItemList';
import BillingItemEditor from './BillingItemEditor';
import InstallmentEditor from '../setup/PaymentPlan/InstallmentEditor';

import './styles/BillingContactTab.scss';
import './styles/BillingAccountOverview.scss';
import './styles/AccountBalancesList.scss';
import './styles/BillingItemList.scss';
import './styles/BillingItemEditor.scss';

const ContactBillingTab = (props) => {
  const { billingAccountId, contactId, subPage = 'ledger' } = props;

  return (
    <div className='billing-contact-tab'>
      <SubPageNavigation
        links={
          [
            ['Overview', `/contacts/${contactId}/billing`],
            ['Ledger', `/contacts/${contactId}/billing/ledger`],
            ['Schedule', `/contacts/${contactId}/billing/schedule`],
            ['Balances', `/contacts/${contactId}/billing/balances`],
            ['Audits', `/contacts/${contactId}/billing/audits`]
          ]
        }
      />

      {subPage === 'overview' && billingAccountId && <BillingAccountOverview billingAccountId={billingAccountId} />}

      {subPage === 'ledger' && billingAccountId && (
        <BillingItemList
          billingAccountId={billingAccountId}
          onAddItem={type => addItem(type, props)}
          onDeleteItem={item => deleteItem(item, props)}
          onEditItem={item => editItem(item, props)}
          onEditInstallments={() => editInstallments(props)}
          onReverseItem={item => reverseItem(item, props)}
          onSendStatement={() => sendStatement(props)}
        />
      )}

      {subPage === 'schedule' && billingAccountId && (
        <BillingItemCalendar contactId={contactId} billingAccountId={billingAccountId} />
      )}

      {subPage === 'balances' && billingAccountId && (
        <AccountBalancesList billingAccountId={billingAccountId} />
      )}

      {subPage === 'audits' && billingAccountId && (
        <BillingAuditViewer
          billingAccountId={billingAccountId}
          onRepostItem={(item, reload) => repostItem(item, { ...props, reload })}
        />
      )}

      {!billingAccountId && <em>This contact does not have a billing account.</em>}

      <ModalRoot
        modals={{
          BillingItemEditor, InstallmentEditor, ConfirmDelete, SendStatement, MissingEmail, UnexpectedError
        }}
      />
    </div>
  );
};

ContactBillingTab.propTypes = {
  contactId: PropTypes.string.isRequired,
  billingAccountId: PropTypes.oneOfType([PropTypes.string, null]).isRequired,
  subPage: PropTypes.string.isRequired
};

export default compose(withRouter, connect())(ContactBillingTab);
